import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { communiqueAction } from 'reduxStateSlice/communique';
import { RootState } from 'store/store';
import { NullableCommunique } from 'types/types';

export default function useCommuniqueState() {
  const dispatch = useDispatch();

  const communiqueData = useSelector(
    (state: RootState) => state.communique,
  ) as NullableCommunique;

  const setCommuniqueData = useCallback((value: NullableCommunique) => {
    dispatch(communiqueAction(value));
  }, [dispatch]);

  return {
    communiqueData,
    setCommuniqueData,
  };
}
